<template>
  <div
    class="picker"
    :class="{ 'picker--error': error }"
    role="radiogroup"
    :aria-labelledby="`${id}_title`"
    @mouseleave="$emit('mouseleave', $event)"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Picker',
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    text: { type: String, default: '' },
    /**
     * Le composant est-il en erreur
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * Le composant est affiché en squelette de chargement
     */
    skeleton: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.picker {
  &__elements {
    margin: 0 rem(-5px);
  }

  .picker-item {
    margin: 0 rem(5px);
  }

  &--error {
    .picker__elements {
      --border-size: #{rem(2px)};

      position: relative;

      &::after {
        content: '';
        position: absolute;
        inset: calc(var(--border-size) * -1);
        border: var(--border-size) solid var(--error-border);
        pointer-events: none;
      }
    }
  }
}
</style>
